import React from 'react';
import RealEstateAuction from '../../components/Admin/RealEstateAuction';

const RealEstateAuctionPage = () => {
  return (
    <div className="admin-page">
      <RealEstateAuction />
    </div>
  );
};

export default RealEstateAuctionPage;

